import { connect } from 'react-redux';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { getOrder, STATE_NEW, STATE_DISPATCHED_SUCCESS } from '../order';
import { Link, withRouter } from 'react-router-dom';
import { STATE_INCOMPLETE, STATE_COMPLETE, STATE_VALIDATING, STATE_INVALID } from '../steps';
import Helmet from 'react-helmet';
import Icon from '../../../ui/Icon';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SidebarComponents from './sidebar';
import styles from './css/Sidebar.scss';
import Sticky from 'react-stickynode';

@injectIntl
export class OrderSidebar extends Component {
    static propTypes = {
        children: PropTypes.node,
        intl: intlShape.isRequired,
        order: ImmutablePropTypes.map,
        router: PropTypes.object.isRequired,
        steps: ImmutablePropTypes.orderedMap.isRequired,
        user: ImmutablePropTypes.map,
    }

    _getStyle(step) {
        return step.get('active')
            ? 'active'
            : styles[step.get('state')];
    }

    _getIcon(step) {
        const props = { fixedWidth: true };

        if (step.get('active')) {
            props.name = 'arrow-circle-o-right';
        }

        switch (step.get('state')) {
        case STATE_COMPLETE:
            props.name = 'check-circle';
            break;
        case STATE_VALIDATING:
            props.name = 'refresh';
            props.spin = true;
            break;
        case STATE_INVALID:
            props.name = 'times-circle';
            break;
        default:
        }

        return <Icon {...props} />;
    }

    render() {

        /*eslint no-unused-vars: ["off", { "ignoreRestSiblings": true }]*/
        const { steps, user, order, router, staticContext, dispatch, ...props } = this.props;
        const { formatMessage } = this.props.intl;

        let content;
        if (order.get('state') === STATE_NEW) {
            content = (
                <ul className={styles.list}>
                    {steps
                        .filter(step => step.get('state') !== STATE_INCOMPLETE || step.get('active'))
                        .map((step, alias) => (
                            <li
                                key={alias}
                                className={this._getStyle(step)}
                            >
                                {
                                    !step.get('active') ? null : (
                                        <Helmet title={formatMessage({ id: step.get('label') })} />
                                    )
                                }

                                <Link to={step.get('route')}>
                                    {this._getIcon(step)}{' '}
                                    <FormattedMessage id={step.get('label')} />
                                </Link>

                                {
                                    SidebarComponents[alias]
                                        ? React.createElement(SidebarComponents[alias])
                                        : null
                                }
                            </li>
                        )).toList()}
                </ul>
            );
        } else if (order.get('state') === STATE_DISPATCHED_SUCCESS) {
            const newOrderHref = steps.first().get('route');

            content = (
                <div>
                    <p><FormattedMessage id='frontend.sidebar_order.new_order_note' /></p>
                    <Link to={newOrderHref}>
                        <FormattedMessage id='frontend.sidebar_order.new_order_link' />
                    </Link>
                </div>
            );
        }

        return (
            <div className={styles.sidebar}>
                <Sticky top='#page-header'>
                    <div {...props} className={styles.content}>
                        <div className={styles.header}>
                            <h4>
                                <FormattedMessage id='frontend.sidebar_order.headline' />
                            </h4>
                            {
                                user ? (
                                    <p className={styles.loginHint}>
                                        <FormattedMessage id='frontend.sidebar_order.authenticated_as' />
                                        {' '} {user.get('name')}.
                                    </p>
                                ) : (
                                    <p className={styles.loginHint}>
                                        <FormattedMessage id='frontend.sidebar_order.not_authenticated' />
                                    </p>
                                )
                            }
                        </div>
                        {content}
                    </div>
                </Sticky>
            </div>
        );
    }
}

export default withRouter(connect(state => ({
    steps: state.steps,
    user: state.session.get('user'),
    router: state.router,
    order: getOrder(state),
}))(OrderSidebar));
